import React from 'react';

import { Chip, SvgIcon, Tooltip } from '@mui/material';

import IconVirus from 'app/ui-kit/icons/Virus.svg';

import useStyles from './styles';

export interface WildExploitedSource {
    type: string;
    idList: string[];
}

interface Props {
    className: string;
    wildExploited: boolean;
    wildExploitedSources: WildExploitedSource[];
}

const WildExploited: React.FC<Props> = ({ wildExploitedSources, className }) => {
    const { classes } = useStyles();
    const href =
        '/search?query=' + wildExploitedSources.map((i) => i.idList.map((i) => `"${i}"`).join(' OR ')).join(' OR ');

    return (
        <Tooltip title="Vulnerability exploited in the wild">
            <a className={classes.link} href={href} target="_blank" rel="noreferrer">
                <Chip
                    className={className}
                    label="In Wild"
                    icon={<SvgIcon className={classes.tagIcon} component={IconVirus} />}
                    onClick={() => {
                        return false; //To keep behaviour of Chip component
                    }}
                />
            </a>
        </Tooltip>
    );
};
export default WildExploited;
